import { getMarketByLocale } from "./locales";
import routes from "../routes";
import { resultToEventMap } from "./resultFunctions/constants";

function getRswUrl(
  offerPlanId,
  ob,
  aid,
  urlSlug,
  resultsScreen,
  isUni = false
) {
  const market = getMarketByLocale(window.ww.locale).toLowerCase();
  const returnPath = `/personalassessment/${urlSlug}${routes.resultsRestored}`;
  const searchParams = new URLSearchParams({
    op: offerPlanId,
    own: "37",
    ob,
    ...(aid && { aid }),
    returnPath,
    assessment_type: urlSlug,
    assessment_result: resultToEventMap[resultsScreen],
    ...(isUni ? { type: "uni" } : {})
  }).toString();
  return `https://www.${
    window.ww.envSubdomain
  }weightwatchers.com/${market}/signup/a/user-account?${searchParams}`;
}

export default getRswUrl;
